<template>
    <div v-loading="mixinLoading">
        <Query ref="query" :page="pageName" @query-click="handleQueryClick" :list="allFilterList"/>
        <!-- 自定义列 -->
        <CustomizeModal 
        ref="refcustomizeModal" 
        :customList="assignObj" 
        :selectList="selectList" 
        :customBtnLoading="customBtnLoading"
        @getCustomList="getCustomList"/>
        <!-- 表格 -->
        <div class="com-table-view-apple">
            <div class="operation-box" id="operation-box">
                <div class="operation-left">
                    <el-button type="primary" size="mini" v-if="pageFuncNames.includes('add_keyword')" :loading="addLoading" @click="handleClickAdd">+ 添加关键词</el-button>
                    <el-divider direction="vertical" v-if="pageFuncNames.includes('add_keyword')"></el-divider>

                    <el-menu
                        v-if="isHasBatchAuth"
                        class="apple-cascader"
                        mode="horizontal"
                        @select="(val)=>handleCommand(val, '')">
                        <el-submenu index="-11" :popper-append-to-body="false">
                            <template slot="title"><span>批量编辑</span></template>
                            <!-- <el-menu-item index="1" :disabled="isHasAuth('edit_campaign_status')||isEmptySelection"><span style="color: #67C23A;">开关-开</span></el-menu-item> -->
                            <el-submenu index="1" v-if="!isHasAuth('edit_keyword_status')">
                                <template slot="title"><span style="color: #67C23A;">开关-开</span></template>
                                <el-menu-item class="sub-menu-item-all" index="1-1" :disabled="isHasAuth('edit_keyword_status') || (multipleSelection.length == 0)">已选中{{multipleSelection.length}}个</el-menu-item>
                                <el-menu-item class="sub-menu-item-all" index="1-2" :disabled="isHasAuth('edit_keyword_status')">全部的{{undeleted_total_cnt}}个</el-menu-item>
                            </el-submenu>
                            <el-submenu index="2" class="err-menu-item" v-if="!isHasAuth('edit_keyword_status')">
                                <template slot="title" ><span style="color: #ff0000;">开关-关</span></template>
                                <el-menu-item class="err-menu-item sub-menu-item-all" index="2-1" :disabled="isHasAuth('edit_keyword_status') || (multipleSelection.length == 0)">已选中{{multipleSelection.length}}个</el-menu-item>
                                <el-menu-item class="err-menu-item sub-menu-item-all" index="2-2" :disabled="isHasAuth('edit_keyword_status')">全部的{{undeleted_total_cnt}}个</el-menu-item>
                            </el-submenu>
                            <el-submenu index="3" v-if="!isHasAuth('edit_bid_amount')">
                                <template slot="title"><span style="color: #333;">最高每次点击费用出价</span></template>
                                <el-menu-item class="sub-menu-item-all" index="3-1" :disabled="isHasAuth('edit_bid_amount') || (multipleSelection.length == 0)">已选中{{multipleSelection.length}}个</el-menu-item>
                                <el-menu-item class="sub-menu-item-all" index="3-2" :disabled="isHasAuth('edit_bid_amount')">全部的{{undeleted_total_cnt}}个</el-menu-item>
                            </el-submenu>
                            <el-submenu index="4" v-if="!isHasAuth('add_as_negative_keyword')">
                                <template slot="title"><span style="color: #333;">添加为否定关键词</span></template>
                                <el-menu-item class="sub-menu-item-all" index="4-1" :disabled="isHasAuth('add_as_negative_keyword') || (multipleSelection.length == 0)">已选中{{multipleSelection.length}}个</el-menu-item>
                                <el-menu-item class="sub-menu-item-all" index="4-2" :disabled="isHasAuth('add_as_negative_keyword')">全部的{{totalCnt}}个</el-menu-item>
                            </el-submenu>
                             <el-submenu index="5" v-if="!isHasAuth('copy_keyword')">
                                 <template slot="title"><span style="color: #333;">复制</span></template>
                                 <el-menu-item class="sub-menu-item-all" index="5-1" :disabled="isHasAuth('copy_keyword') || (multipleSelection.length == 0)">已选中{{multipleSelection.length}}个</el-menu-item>
                                 <el-menu-item class="sub-menu-item-all" index="5-2" :disabled="isHasAuth('copy_keyword')">全部的{{totalCnt}}个</el-menu-item>
                             </el-submenu>
                        </el-submenu>
                    </el-menu>
                    <span style="padding-left: 8px;" v-if="multipleSelection.length>0">已选中{{multipleSelection.length}}条</span>
                    
                </div>
                <div class="operation-right">
                    <el-button
                        icon="el-icon-s-operation"
                        size="mini"
                        @click="handleShowDefineRow">自定义列</el-button>
                    <el-button
                        icon="el-icon-download"
                        size="mini"
                        v-if="!isHasAuth('export')"
                        :loading="exportLoading"
                        @click="handleExport">导出</el-button>
                </div>
            </div>

            <div style="min-height: 300px;">
                <jt-table
                    :data="tableData"
                    border
                    style="width: 100%;"
                    ref="multipleTable"
                    :row-key="getRowKey"
                    :header-cell-style="{background:'#e8eaec',color:'#333'}"
                    @cell-mouse-enter="handleCellMouseEnter"
                    @selection-change="handleSelectionChange"
                    @sort-change="handlesortchange"
                    @header-dragend="handleDragEnd"
                    v-loading="!mixinLoading && loading"
                    header-row-class-name="jt_sticky"
                >
                    <!--复选框）-->
                    <el-table-column
                        type="selection"
                        width="50"
                        align="center"
                        fixed="left"
                        :selectable="selectable" 
                        >
                    </el-table-column>
                    <!-- 默认 -->
                    <el-table-column
                        :prop="column.name"
                        :label="column.display_name"
                        :align="column.align"
                        :width="getLocalStorageWidth?.[pageName]?.[column.name] || column.width || null"
                        :fixed="column.fixed !='' ? column.fixed : false"
                        :sortable="getsortable(column['field_type'], column.name)"
                        v-for="(column, index) in columns"
                        :key="index"
                        :render-header="(h, values)=>renderHeader(h, values, column)"
                        >
                        <template slot-scope="scope">
                            <div v-if="scope.$index===0" class="">
                                <span v-if="column.name==firstColumnName">合计</span>
                                <div v-else-if="scope.row[column.name]">
                                    <div class="currency_flex" v-if="getcurrency(scope.row, column.name)['has']">
                                        <div class="column_name text-nowrap">
                                            {{ getcurrency(scope.row, column.name)['name'] }}
                                        </div>
                                        <div class="column_currency">
                                            {{ getcurrency(scope.row, column.name)['currency'] }}
                                        </div>
                                    </div>
                                    <div class="currency_flex" v-else> {{ getcurrency(scope.row, column.name)['name'] }}</div>
                                </div>
                                <span v-else>-</span>
                            </div>
                            <div class="table_operate" v-else-if="column.name=='operate'">
                                <el-button type="text" @click="showDataModal(scope.row)" v-if="!isHasAuth('data')">数据</el-button>
                                <span v-else>-</span>
                            </div>
                            <template v-else>
                                <div class="lineheightmax text-color-primary pointer" v-if="column.field_type=='1' && column.name=='campaign_name'&&false"
                                     @click="handleClickCampaignName(scope.row)">
                                    {{scope.row[column.name]}}
                                </div>

                                <!-- 开关 -->
                                <el-switch
                                    v-else-if="column.field_type=='1' && column.name=='keyword_status'"
                                    v-model="scope.row.keyword_status"
                                    :disabled="isHasAuth('edit_keyword_status') || !selectable(scope.row) || scope.row['keyword_status_disabled']"
                                    active-value="ACTIVE"
                                    inactive-value="PAUSED"
                                    @change="(val)=>handleSwith(scope.row, column.name, val)">
                                </el-switch>

                                <!-- bid_amount -->
                                <div
                                    v-else-if="column.field_type=='1' && column.name=='bid_amount'"
                                    class="custom_input" :class="[active == scope.$index ? 'active' : '']" ref="myParagraphkey">
                                    <el-input
                                        v-if="active != scope.$index"
                                        size="mini"
                                        class="custom_input_el"
                                        :value="formatNumberWithCommas(Number(scope.row.bid_amount),'bid_amount',scope.row)"
                                        @focus="handleFocus(scope.row.bid_amount, scope.$index, 'list')"
                                        readonly
                                        ref="myParagraphread"
                                        :disabled="isHasAuth('edit_bid_amount') || !selectable(scope.row)"
                                    >
                                        <template slot="append" v-if="active != scope.$index">{{scope.row.bid_amount_currency}}</template>
                                    </el-input>
                                    <el-input
                                        v-if="(active == scope.$index)"
                                        size="mini"
                                        placeholder="请输入"
                                        class="custom_input_el"
                                        v-model="scope.row.bid_amount"
                                        @blur="handleBlur(scope.$index)"
                                        @input="(value)=>handleInput(value, scope.row)"
                                        ref="myParagraphread"
                                        :disabled="scope.row['edit_bid_amount'] || !selectable(scope.row)"
                                    >
                                        <template slot="append" v-if="active != scope.$index">{{scope.row.bid_amount_currency}}</template>
                                    </el-input>
                                    <div class="custom_input_btn" v-if="active == scope.$index">
                                        <button class="custom_input_success" :class="{'btn-disabled': scope.row['edit_bid_amount_disabled']}" :disabled="scope.row['edit_bid_amount_disabled']" @click="handleOK(scope.row, 'bid_amount', 'list')"><i class="el-icon-check"></i></button>
                                        <button class="custom_input_close" :class="{'btn-disabled': scope.row['edit_bid_amount_disabled']}" :disabled="scope.row['edit_bid_amount_disabled']" @click="handleClose(scope.row, scope.$index, 'list')"><i class="el-icon-close"></i></button>
                                    </div>
                                </div>

                                <!-- 状态 -->
                                <div
                                    v-else-if="column.field_type=='1' && column.name=='keyword_display_status'"
                                    :class="getStatusColor(scope.row['keyword_display_status'], scope.row['keyword_display_status_name'])">
                                    {{scope.row['keyword_display_status_name']}}
                                </div>

                                <!-- 投放日期 -->
                                <div v-else-if="column.field_type=='1' && column.name=='start_end_time'">
                                    <p>开始:{{scope.row['start_time']}}</p>
                                    <p>结束:{{scope.row['end_time']}}</p>
                                </div>

                                <!--关键词-->
                                <div v-else-if="column.field_type=='1' && column.name=='key_word_text'">
                                    <span v-if="scope.row.match_type=='精准匹配'">[{{scope.row.key_word_text}}]</span>
                                    <span v-else>{{scope.row.key_word_text}}</span>
                                </div>

                                <div v-else-if="column.field_type=='2'">
                                    <div class="currency_flex" v-if="getcurrency(scope.row, column.name)['has']">
                                        <div class="column_name text-nowrap">
                                            {{ getcurrency(scope.row, column.name)['name'] }}
                                        </div>
                                        <div class="column_currency">
                                            {{ getcurrency(scope.row, column.name)['currency'] }}
                                        </div>

                                    </div>
                                    <div class="currency_flex" v-else> {{ getcurrency(scope.row, column.name)['name'] }}</div>
                                </div>

                                <div class="lineheightmax" v-else><span ref="paragraphs">{{scope.row[column.name]}}</span></div>
                            </template>
                        </template>
                    </el-table-column>
                </jt-table>
            </div>

            <div class="component_pagination">
                <el-pagination
                    v-if="pagination"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pn"
                    :page-sizes="[30, 50, 100]"
                    :page-size="rn"
                    :pager-count="5"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalCnt">
                </el-pagination>
            </div>

            <el-dialog
                :title="null"
                :visible.sync="dialogVisible"
                :close-on-click-modal=false
                :close-on-press-escape=false
                :show-close=false
                :destroy-on-close=true
                width="450px"
                custom-class="apple-dialog-err"
                :before-close="handleClose">
                <div>
                    <h5 class="tac font16px">{{dialogTypeTitle}}</h5>
                    <p class="tac text-color-error pt10 pb20">请勿刷新页面，刷新页面会导致无法及时收到最新结果</p>
                </div>
            </el-dialog>

            <BatchBidAmountModal ref="batchBidAmountModal" :total-cnt="undeleted_total_cnt" :is-all="isBatchAll" :query="props_params" :list="multipleSelection" @update="getListBody(props_params)" />


            <NegativeKeywordModal ref="negativeKeywordModal" :action-rows="actionRows" :form-data="actionRowData" :action-type="actionType" @update="clearMultipleSelection"/>
            <KeywordModal ref="keywordModal" :action-rows="actionRows" :form-data="actionRowData" @update="getListBody(props_params)" :action-type="actionType"/>
            <el-tooltip ref="cellTip" v-model="showPopper" placement="top-start" effect="dark">
                <div class="tip-apple-content" slot="content">{{tipContent}}</div>
            </el-tooltip>

        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import Query from "../../components/query.vue";
    import CustomizeModal from '../../modal/customizeModal';
    import API from '@/api/marketManage/apple/index';
    import BatchBidAmountModal from '../modal/batchBidAmountModal';
    import { cloneDeep, debounce } from 'lodash'
    import NegativeKeywordModal from '../modal/negativeKeywordModal';
    import KeywordModal from '../modal/keywordModal';
    import {dataDetailModal} from '../../modal/index';
    import {setStorage, getStorage, removeStorage} from '@/utils/index.js';
    import {
        handleDocumentNoctiyClick, 
        get_err_info,
        get_flag_single_post_html,
        get_flag_suc_html,
        get_flag_single_err_html, 
        get_flag_mul_err_html
    } from "../../components/getFlagHtml.js";
    const other_Table_columns_no_sort = ['plan_name_start_date', 'creation_time', 'start_end_time'] //需要独立处理的排序
    export default {
        name: "KeywordPage",
        props:{
            pageDimension:Array,
            pageFields:Array,
            pageFunc:Array,
            zone:String,
            rangeTime:Array,
            mixinLoading:Boolean,
            pageActionNames:Array,
        },
        components: {
            Query,
            CustomizeModal,
            BatchBidAmountModal,
            NegativeKeywordModal,
            KeywordModal,
        },
        inject:['priceDecimalConfig'],
        data() {
            return {
                pageName:'apple_promotion_manage_keyword',
                value:true,
                props_params: {}, //query 组件吐出参数 对象形式  (一般用在勾选操作与导出)
                btnloading: false,  //每日预算按钮loading
                active: -1, // 每日预算点击
                drawer: false, //抽屉
                pagination: true,
                pn: 1,
                rn: 30,
                totalCnt:0,
                undeleted_total_cnt:0,
                selectList: [],
                multipleSelection: [],
                columns: [],
                tableData:[],
                cloneTableData: [],
                customBtnLoading: false, //自定义列按钮loading
                activeIndex: -1, //选中的详情条数
                cacha_money: '',  //缓存每日预算
                cacha_name: '', //缓存广告系列名称
                infoValue: false, // 详情开关
                infoactive: false, // 详情广告名称 显示输入与否
                infoysactive: false, //详情每日预算  显示与否
                infoName: '', // 广告系列名称
                show: false, //处理表格头显示后 显示表格
                loading: false, //处理表格loading
                options: [
                    {
                        value: '1',
                        label: '开关-开',
                        children: [
                            {
                                value: 'all',
                                label: '全选',
                            }
                        ]
                    },
                    {
                        value: '2',
                        label: '开关-关',
                    },
                    {
                        value: '3',
                        label: '复制',
                    },
                    {
                        value: '4',
                        label: '每日预算',
                    },
                    {
                        value: '5',
                        label: '删除',
                    }
                ],
                notifyarr: [],
                dialogVisible: false,   //各种错误提示
                dialogBoo: true,   // 是否失败
                dialogType: 1,   //1单个处理 2多个处理
                dialogTypeTitle: '批量开关-开请求成功，正在处理...', //显示提示头
                dialogTypeBody: '1000027869，正在处理，请稍后', //显示提示头
                mulerrIds: '',
                mulErr:'',
                mulexc: '',
                cachaHeader: 1,
                isBatchAll:false,
                allKeywords:[],
                actionType:'',      // 记录关键词弹窗的 添加/复制
                showPopper: false, //浮层提醒
                tipContent: '',    //浮层提醒内容
                exportLoading:false,
                addLoading:false,
                getLocalStorageWidth:{}, //缓存宽度
                preData:{
                    org_id:'',
                    org_name:'',
                    campaign_id:'',
                    campaign_name:'',
                    adgroup_id:'',
                    adgroup_name:'',
                },
            }
        },
        computed:{
            ...mapGetters(['tabs_map', 'apple_reload','apple_list_page_query']),
            decimalConfig(){
                return this.priceDecimalConfig();
            },
            allFilterList(){
                let dimensions = cloneDeep(this.pageDimension)
                /* 需要过滤掉[操作]列 */
                return dimensions.filter(item=>item['config'] && item.name!='operate').map(item=>{
                    item.config = JSON.parse(item.config);
                    return item;
                })
            },
            assignObj() {
                let chone_list = cloneDeep(this.pageDimension)
                let chone_list_pageFields = cloneDeep(this.pageFields)
                let res_dime = chone_list.map(item=>{
                    item['meconfig'] = item['config'] && JSON.parse(item.config);
                    return item;
                })
                let res_pageFields = chone_list_pageFields.map(item=>{
                    // item.config = item['config'] && JSON.parse(item.config);
                    if(item['children']) {
                        item['children'].map(itemc => {
                            itemc['meconfig'] = itemc['config'] && JSON.parse(itemc['config']);
                            return itemc
                        })
                    }
                    return item;
                })
                let baselist = {
                    id : "b_1000",
                    name: 'base',
                    display_name: '基础信息',
                    children: res_dime
                }
                return [baselist,...res_pageFields]
            },
            getappledialogerr() {
                if(this.mulErr != '' && this.mulexc != '') {
                    return 1
                }else if(this.mulErr != '' || this.mulexc != ''){
                    return 2
                }else{
                    return 3
                }
            },
            isEmptySelection(){
                return this.multipleSelection.length<=0;
            },
            isHasAdGroupAction(){
                let tabsMap =  this.tabs_map||{};
                let apple =tabsMap.apple||[];
                return apple.map(item=>item.name).includes('apple_adgroup');
            },
            pageFuncNames(){
                return (this.pageFunc||[]).map(item=>item.name);
            },
            isHasBatchAuth(){
                let funcNames = this.pageFuncNames||[];
                return funcNames.includes('copy_keyword')||funcNames.includes('add_as_negative_keyword')||funcNames.includes('edit_bid_amount')||funcNames.includes('edit_keyword_status');
            },
            actionRows(){
                if(this.isBatchAll){
                    return this.allKeywords.map(item=>{
                        return {
                            key_word_text:item.key_word_text,
                            match_type:item.match_type=='BROAD'?'广泛匹配':item.match_type=='EXACT'?'精准匹配':'',
                            bid_amount:item.bid_amount||'',
                            org_id:item.org_id,
                            org_name:item.org_name,
                            campaign_id:item.campaign_id,
                            campaign_name:item.campaign_name,
                            adgroup_id:item.adgroup_id,
                            adgroup_name:item.adgroup_name,
                            bid_amount_currency:item.bid_amount_currency,
                        }
                    })
                }
                return this.multipleSelection.map(item=>{
                    return {
                        key_word_text:item.key_word_text,
                        match_type:item.match_type||'',
                        bid_amount:item.bid_amount||'',
                        org_id:item.org_id,
                        org_name:item.org_name,
                        campaign_id:item.campaign_id,
                        campaign_name:item.campaign_name,
                        adgroup_id:item.adgroup_id,
                        adgroup_name:item.adgroup_name,
                        bid_amount_currency:item.bid_amount_currency,
                    }
                })
            },
            actionRowData(){
                let orgIds = this.actionRows.map(item=>item.org_id).filter(item=>!!item);
                let campaignIds = this.actionRows.map(item=>item.campaign_id).filter(item=>!!item);
                let adGroupIds = this.actionRows.map(item=>item.adgroup_id).filter(item=>!!item);
                let row =this.actionRows[0]||{};
                let data = {};

                /* 判断是否需要设置默认值 */
                if(orgIds.every(item=>item===row.org_id)){
                    data.org_id = row.org_id;
                    data.org_name = row.org_name;
                }
                if(campaignIds.every(item=>item===row.campaign_id)){
                    data.campaign_id = row.campaign_id;
                    data.campaign_name = row.campaign_name;
                }
                if(adGroupIds.every(item=>item===row.adgroup_id)){
                    data.adgroup_id = row.adgroup_id;
                    data.adgroup_name = row.adgroup_name;
                }
                return data;
            },
            firstColumnName(){
                let column = this.columns[0]||{};
                return column.name||'-';
            }
        },
        watch: {
            apple_reload: function(val) {
                this.getListBody(this.props_params)
            }
        },
        created(){
            this.getLocalStorageWidth = getStorage('localStorage','tableWidthMap') || {};
        },
        mounted() {
            this.getEventTip()
            // 处理表格内部blur事件
            document.addEventListener('click', this.handleDocumentKeywordClick);

            this.getListHead((res)=>{
                const fields = res && res.map(item=>item['name'])
                this.props_params['fields'] = []
                this.props_params['fields'] = fields
            })

        },
        beforeDestroy() {
            // 处理表格内部blur事件
            // 在组件销毁前移除全局点击事件监听器
            document.removeEventListener('click', this.handleDocumentKeywordClick);

        },
        methods:{
            getcurrency(rows, name) {
                let name_currency = `${name}_currency`
                if(rows[name_currency]) {
                    return {
                        has: true,
                        name: rows[name],
                        currency: rows[name_currency],
                    }
                }else{
                    return {
                        has: false,
                        name: rows[name]
                    }
                }
            },
            // query 查询  isClear为true：表示点击的是【清空筛选】
            handleQueryClick(params,isClear) {
                console.log('params', params)
                this.$refs.query.setSubmitLoading(true);
                if(isClear){
                    this.$refs.query.setClearLoading(true);
                }
                let range_time = Array.isArray(this.rangeTime) && this.rangeTime.length != 0 ? `${this.rangeTime[0]}/${this.rangeTime[1]}` : ''
                // this.props_params = {...params, range_time: range_time, time_zone: this.zone, pn: this.pn, rn: this.rn}
                this.pn = 1
                this.props_params = Object.assign(this.props_params,params,{range_time: range_time, time_zone: this.zone, pn: this.pn, rn: this.rn})
                // if(this.cachaHeader == 1) {
                //     this.getListHead((res)=>{
                //         const fields = res && res.map(item=>item['name'])
                //         this.props_params['fields'] = []
                //         this.props_params['fields'] = fields
                //         this.getListBody(this.props_params,isClear)
                //     })
                // }else{
                //     this.getListBody(this.props_params,isClear)
                // }
                this.getListBody(this.props_params,isClear)
            },
            getRowKey(row) {
                return row['keyword_id']
            },
            getShowInfoItem(arr, name) {
                if(Array.isArray(arr) && arr.length != 0) {
                    let isshow = arr.some(item=>item['name'] == name)
                    return true
                }else{
                    return false
                }
            },
            // 判断是否显示tip事件
            getEventTip() {
                const _this = this;
                const cellTip = this.$refs.cellTip;
                const delay = 200;

                // 超长提示事件
                $(this.$el).on('mouseenter.tdcell', '.lineheightmax', debounce(function() {

                    const $cell = $(this);
                    if ($cell[0].offsetHeight === $cell[0].scrollHeight) {
                        return;
                    }

                    cellTip.referenceElm = $cell[0];
                    _this.showPopper = true;
                    _this.tipContent = $cell.text();
                }, delay))
                .on('mouseleave.tdcell', '.lineheightmax', function() {
                    if (!_this.showPopper) {
                        return;
                    }

                    _this.showPopper = false;
                    setTimeout(() => {
                        _this.showPopper = false;
                    }, delay);
                });
            },
            getshowTip(name) {
                // campaign_name 广告系列 countries_or_regions 国家跟地区 campaign_display_status 状态 company_name  客户 org_name广告系列组 app_info 产品 bloc_name集团
                const showTip = ['key_word_text', 'adgroup_name','org_name','countries_or_regions', 'campaign_display_status', 'company_name', 'app_info', 'bloc_name']
                if(showTip.includes(name)) {
                    return true
                }else{
                    return false
                }
            },
            getParagraphHeights() {
                this.$nextTick(() => {
                    const paragraphs = this.$refs.paragraphs;

                    // 遍历每个p标签并获取高度
                    this.paragraphHeights = paragraphs.map(paragraph => paragraph.clientHeight);

                    // 打印高度数组
                    console.log('Paragraph Heights:', this.paragraphHeights);
                });
            },
            // 获取权限
            isHasAuth(name){
                let isauth = this.pageFunc.some(item => item['name'] == name)
                return !isauth
            },
            // 获取列表头
            getListHead(callback) {
                this.$refs.query.setSubmitLoading(true);
                this.loading = true
                this.columns.length = 0
                API.getCustomField({field_type: 'apple_promotion_manage_keyword'}).then(res => {
                    let resData = res.data || []
                    this.selectList = resData
                    const width140 = ['keyword_id', 'campaign_id', 'org_id', 'account_name_start_date', 'adgroup_id', 'keyword_display_status', 'creation_time']
                    const width110 = ['account_yy_type', 'yy_name', 'keyword_status', 'supply_source', 'match_type']
                    this.columns = resData.map(item=>{
                        item["display_name"] = item.label
                        item['align'] = 'left'
                        // 宽度特殊处理
                        if(item['field_type'] == 2) {
                            item['align'] = 'right'
                            let nums = item['display_name'].length
                            /* 曝光均价：单独设置宽度250 */
                            // item['width'] = item.name=='imp_price'?250:((nums * 12)) + 60
                            if(item.name=='imp_price' || item.name == 'local_spend') {
                                item['width'] = 250
                            }else {
                                item['width'] = ((nums * 12)) + 60
                            }
                        }else{
                            if(width140.includes(item.name)) {
                                item['width'] = 120
                            }else if(width110.includes(item.name)){
                                item['width'] = 90
                            }else{
                                item['width'] = 190
                            }
                        }
                        if(item.name == 'keyword_status') {
                            item['align'] = 'center'
                        }
                        if(item.name == 'bid_amount') {
                            item['align'] = 'right'
                        }
                        return item
                    })
                    // this.show = true
                    // this.cachaHeader = 2
                    callback && callback(resData)
                }, err=>{
                    this.loading = false
                    this.$message.error(err.info)
                })
            },
            setListQueryData(params){
                let queryData = {
                    org_id:this.props_params.org_id||[],
                    org_name:this.props_params.org_name||[],
                    campaign_id:this.props_params.campaign_id||[],
                    campaign_name:this.props_params.campaign_name||[],
                    adgroup_id:this.props_params.adgroup_id||[],
                    adgroup_name:this.props_params.adgroup_name||[],
                };

                this.$store.commit('apple/SET_LIST_PAGE_QUERY',queryData);
                localStorage.setItem('AppleQueryRestoreData',JSON.stringify({
                    value:params,
                    tabName:this.$route.name,
                }));
            },
            //  获取列表体
            getListBody(params,isClear) {
                    this.loading = true
                    this.$refs.query.setSubmitLoading(true);
                    if(isClear){
                        this.$refs.query.setClearLoading(true);
                    }
                    this.setListQueryData(params);
                    API.getKeywordList(params).then(res => {
                        this.loading = false
                        this.$refs.query.setSubmitLoading(false);
                        if(isClear){
                            this.$refs.query.setClearLoading(false);
                        }
                        let resData = res.data
                        let table_list = resData.list && resData.list.map(item=>{
                            item['keyword_status_disabled'] = false  // 开关 disabled  默认关
                            item['delbtn_status_disabled'] = false  // 删除按钮 disabled  默认关
                            item['edit_bid_amount_disabled'] = false  //每日预算 默认关

                            item['cache_keyword_status'] = item['keyword_status']
                            item['cache_keyword_display_status'] = item['keyword_display_status']
                            item['cache_keyword_display_status_name'] = item['keyword_display_status_name']

                            if(item['bid_amount'] == '-') {
                                item['bid_amount'] = '' 
                                item['cache_bid_amount'] = ''
                            }else{
                                item['cache_bid_amount'] = item['bid_amount']
                            }
                            return item
                        })

                        this.tableData = [resData.total||{}].concat(table_list);
                        this.totalCnt = resData.totalCnt
                        this.undeleted_total_cnt = resData.undeleted_total_cnt||0;
                        this.active = -1
                        this.$nextTick(()=>{
                            this.$refs.multipleTable.doLayout()
                        })
                    }, err=>{
                        this.loading = false
                        if(err.code =='403'){
                            this.$confirm(err.info, '提示', {
                                confirmButtonText: '刷新',
                                type: 'warning',
                                showClose: false,
                                closeOnClickModal: false,
                                closeOnPressEscape: false
                                }).then(() => {
                                    window.location.reload()
                                }).catch(() => {
                                    this.loading = false
                                });
                            return        
                        }
                        this.$message.error(err.info)
                        this.active = -1
                        this.$refs.query.setSubmitLoading(false);
                        if(isClear){
                            this.$refs.query.setClearLoading(false);
                        }
                    })
            },
            // 获取状态颜色
            getStatusColor(val, reason) {
                let texts = reason !='-' ? 'pointer' : ''
                if(val == 'RUNNING') {
                    return `lineheightmax text-color-success apple_states ${texts}`
                }else if(val == 'ON_HOLD') {
                    return `lineheightmax text-color-failed apple_states ${texts}`
                }else if(val == 'CAMPAIGN_ON_HOLD') {
                    return `lineheightmax text-color-failed apple_states ${texts}`
                }else{
                    return `lineheightmax apple_states ${texts}`
                }
            },
            // 设置不可以选择
            selectable(row, index) {
                if(index===0) return false;
                if(row['keyword_display_status'] == 'DELETED') {
                    return false
                }else{
                    return true
                }
            },
            // 千分位处理
            formatNumberWithCommas(number,name,rows) {
                // Check if the input is a valid number
                let limit = 2;
                if(rows.bid_amount_currency=='美元'&&name=='bid_amount'){
                    let USDConfig = this.decimalConfig.find(item=>item.type=='keyword'&&item.field=='bid_amount'&&item.currency=='USD')||{};
                    limit = USDConfig.decimal_places||limit;
                }

                if (isNaN(number) || number == '') {
                    return "-";
                }
                let formattedNumber = number.toLocaleString();

                if(name&&name=='default_bid_amount'){
                    return formattedNumber;
                }else if (formattedNumber.indexOf('.') !== -1) {
                    formattedNumber = parseFloat(number).toFixed(limit);
                }
                return formattedNumber;
            },
            // 自定义列
            handleShowDefineRow () {
                this.$refs.refcustomizeModal.showModal();
            },
            // 获取自定义列
            getCustomList(values) {
                console.log('values', values)
                this.customBtnLoading = true
                API.setCustomField({
                    field_type: 'apple_promotion_manage_keyword',
                    fields: values
                }).then(res => {
                    console.log('res', res)
                    this.customBtnLoading = false
                    this.$refs.refcustomizeModal.handleClose()
                    this.$message({
                        message: res.info,
                        type: 'success'
                    });
                    this.getListHead((res)=>{
                        const fields = res && res.map(item=>item['name'])
                        this.props_params['fields'] = []
                        this.props_params['fields'] = fields
                        
                        if(!fields.includes(this.props_params['order_by'])) {
                            this.props_params['order_by'] = ''
                            this.props_params['order_type'] = ''
                        }
                        this.getListBody(this.props_params);
                    })
                }, (err) => {
                    this.customBtnLoading = false
                    console.log('error', err);
                    this.$message.error(err.info)
                })
            },
            // 多选
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            // 表格鼠标滑过
            handleCellMouseEnter(row, column, cell, event) {

            },
            // 批量操作
            /**
             * 开 1  ACTIVE
             * 关 2  PAUSED
             * 复制 3
             * 每日预算 4
             * 删除 5
             */
            handleCommand(el, index) {
                let selected_list_id = this.multipleSelection.map(item=>item.keyword_id)
                console.log(el, selected_list_id)
                // 开
                if(el == '1-1') {
                    if(selected_list_id.length == 1) {
                        let selectIndex = this.tableData.findIndex((element) => element['keyword_id'] == selected_list_id[0])
                        this.handleSwith(this.tableData[selectIndex], 'keyword_status', 'ACTIVE')
                        return
                    }
                    this.handleSwithMul('keyword_status', selected_list_id, 'ACTIVE', '批量开关-开请求成功，正在处理…')
                }
                // 关
                if(el == '2-1') {
                    if(selected_list_id.length == 1) {
                        let selectIndex = this.tableData.findIndex((element) => element['keyword_id'] == selected_list_id[0])
                        this.handleSwith(this.tableData[selectIndex], 'keyword_status', 'PAUSED', '批量开关-关请求成功，正在处理…')
                        return
                    }
                    this.handleSwithMul('keyword_status', selected_list_id, 'PAUSED', '批量开关-开请求成功，正在处理…')
                }
                // 全 开
                if(el == '1-2') {
                    if(this.undeleted_total_cnt>5000) return this.$message.error('批量操作单次支持5000个，请减少数量后重试');
                    this.handleSwithAllMul('keyword_status', this.props_params, 'ACTIVE', '批量开关-开请求成功，正在处理…')
                }
                // 全 关
                if(el == '2-2') {
                    if(this.undeleted_total_cnt>5000) return this.$message.error('批量操作单次支持5000个，请减少数量后重试');
                    this.handleSwithAllMul('keyword_status', this.props_params, 'PAUSED', '批量开关-关请求成功，正在处理…')
                }
                // 复制
                if(el == '5-1'||el=='5-2') {
                    let checkedList = this.multipleSelection;
                    if(el=='5-1'&&checkedList.length<=0){
                        return this.$message.error('请选择需要操作的数据');
                    }
                    if(el=='5-2'){
                        if(this.totalCnt<=0) return this.$message.error('列表暂无数据，无法进行该操作');
                        if(this.totalCnt>5000) return this.$message.error('最多可操作5000个关键词');
                        this.$confirm('您确认要操作全部的 '+this.totalCnt+' 个关键词吗?', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {
                            API.checkKeywordCopyKeyword().then(()=>{
                                API.getAllKeywords({
                                    query:this.props_params,
                                },{
                                    timeout: 120 * 1000,
                                }).then((res)=>{
                                    this.allKeywords = res.data||[];
                                    this.isBatchAll = true;
                                    this.actionType = 'keywordCopyKeyword';
                                    this.$refs.keywordModal.showModal();
                                },err=>{
                                    console.log('getAllKeywords err',err);
                                    this.$message.error(err.info||'操作失败');
                                });
                            },err=>{
                                this.$message.error(err.info||'请求异常');
                            })
                        }).catch((e) => {
                            console.log('checkKeywordBidAmount e',e);
                        });
                    }else{
                        this.isBatchAll = false;
                        API.checkKeywordCopyKeyword().then(()=>{
                            this.actionType = 'keywordCopyKeyword';
                            this.$refs.keywordModal.showModal();
                        },err=>{
                            this.$message.error(err.info||'请求失败');
                        })
                    }
                }
                // 添加为否定关键词
                if(el=='4-1'||el=='4-2'){
                    let checkedList = this.multipleSelection;
                    if(el=='4-1'&&checkedList.length<=0){
                        return this.$message.error('请选择需要操作的数据');
                    }
                    if(el=='4-2'){
                        if(this.totalCnt<=0) return this.$message.error('列表暂无数据，无法进行该操作');
                        if(this.totalCnt>5000) return this.$message.error('最多可操作5000个关键词');
                        this.$confirm('您确认要操作全部的 '+this.totalCnt+' 个关键词吗?', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {
                            API.checkKeywordAddAsNegativeKeyword().then(()=>{
                                this.isBatchAll = true;
                                API.getAllKeywords({
                                    query:this.props_params,
                                },{
                                    timeout: 120 * 1000,
                                }).then((res)=>{
                                    this.allKeywords = res.data||[];
                                    this.actionType = 'keywordAddAsNegativeKeyword';
                                    this.$refs.negativeKeywordModal.showModal();
                                },err=>{
                                    console.log('checkKeywordBidAmount err',err);
                                    this.$message.error(err.info||'操作失败');
                                });
                            },err=>{
                                this.$message.error(err.info||'请求失败');
                            });
                        }).catch((e) => {
                            console.log('getAllKeywords e',e);
                        });
                    }else{
                        this.isBatchAll = false;
                        API.checkKeywordAddAsNegativeKeyword().then(()=>{
                            this.actionType = 'keywordAddAsNegativeKeyword';
                            this.$refs.negativeKeywordModal.showModal();
                        },err=>{
                            this.$message.error(err.info||'请求失败');
                        });
                    }
                }

                // 编辑最高每次点击费用出价
                if(el=='3-1'||el=='3-2'){
                    let checkedList = this.multipleSelection;
                    if(el=='3-1'&&checkedList.length<=0){
                        return this.$message.error('请选择需要操作的数据');
                    }
                    let currencyText = (checkedList[0]||{}).bid_amount_currency;
                    if(el=='3-2'||checkedList.every(item=>item.bid_amount_currency==currencyText)){
                        if(el=='3-2'){
                            if(this.totalCnt<=0) return this.$message.error('列表暂无数据，无法进行该操作');
                            if(this.undeleted_total_cnt>5000) return this.$message.error('批量操作单次支持5000个，请减少数量后重试');
                            this.$confirm('您确认要操作全部的 '+this.undeleted_total_cnt+' 个关键词吗?', '提示', {
                                confirmButtonText: '确定',
                                cancelButtonText: '取消',
                                type: 'warning'
                            }).then(() => {
                                API.checkKeywordBidAmount({
                                    query:this.props_params,
                                },{
                                    timeout: 120 * 1000,
                                }).then(()=>{
                                    this.isBatchAll = true;
                                    this.showBatchBidAmountModal();
                                },err=>{
                                    console.log('checkKeywordBidAmount err',err);
                                    this.$message.error(err.info||'操作失败');
                                });
                            }).catch((e) => {
                                console.log('checkKeywordBidAmount e',e);
                            });

                        }else{
                            this.isBatchAll = false;
                            this.showBatchBidAmountModal();
                        }
                    }else{
                        return this.$message.error('选择的广告系列包含多种金额单位，需要选择同单位的系列批量修改');
                    }
                }
            },
            showBatchBidAmountModal(){
                this.$refs.batchBidAmountModal.showModal();
            },
            handleCascader(value) {
                console.log('value', value)
            },
            showBatchBudgetModal(){
                this.$refs.batchBudgetModal.showModal();
            },
            // 开关  单个
            handleSwith(rows, select_name, status) {
                // 单个请求中
                let flag_single_post_html = get_flag_single_post_html(rows['keyword_id'])
                let currency_time = new Date().valueOf()
                let current_name = `${select_name}_${currency_time}`
                let current_tip = this.$notify({
                    showClose: false,
                    duration: 0,
                    dangerouslyUseHTMLString: true,
                    message: flag_single_post_html
                });
                // this.notifyarr.push(notifyTip)

                this.$store.commit('apple/ADD_NOTIFY',{
                    id: current_name,
                    value: current_tip,
                });

                rows['keyword_status_disabled'] = true

                let fetchparams = {keyword_id: [rows['keyword_id']], status: status, current_name: current_name,is_all: false}
                console.log('0000', fetchparams)
                this.fetchSwith(fetchparams, current_name, select_name)
                
            },
            fetchSwith(fetchparams, old_current_name, select_name) {
                API.edittargeting(fetchparams).then(res=>{
                    let resultData = res.data
                    // 处理单个请求中 关闭
                    let current_closed = this.$store.getters.apple_notify[old_current_name]
                    if(current_closed) {
                        current_closed.close()
                    }
                    // 单个请求成功
                    let flag_single_post_html = get_flag_suc_html(res['info'], resultData['msg'])
                    // let currency_time = new Date().valueOf()
                    // let current_name = `${select_name}_${currency_time}`
                    this.$notify({
                        showClose: false,
                        duration: 5000,
                        dangerouslyUseHTMLString: true,
                        message: flag_single_post_html
                    });

                    // 赋予表格状态
                    let select_id = fetchparams['keyword_id']
                    let selectIndex = this.tableData.findIndex((element) => element['keyword_id'] == select_id)
                    if(selectIndex != -1) {
                        this.tableData[selectIndex]['keyword_status'] = resultData['status']
                        this.tableData[selectIndex]['keyword_display_status'] = resultData['display_status']
                        this.tableData[selectIndex]['keyword_display_status_name'] = resultData['serving_state_name']

                        this.tableData[selectIndex]['cache_keyword_status'] = resultData['status']
                        this.tableData[selectIndex]['cache_keyword_display_status'] = resultData['display_status']
                        this.tableData[selectIndex]['cache_keyword_display_status_name'] = resultData['serving_state_name']


                        this.tableData[selectIndex]['keyword_status_disabled'] = false

                        console.log('active', this.tableData[selectIndex])
                    }
                    
                },err => {
                    // 处理单个请求中 关闭
                    let resultData = err.data
                    let current_closed = this.$store.getters.apple_notify[old_current_name]
                    if(current_closed) {
                        current_closed.close()
                    }

                    if(err.code =='403'){
                        this.$confirm(err.info, '提示', {
                                confirmButtonText: '刷新',
                                type: 'warning',
                                showClose: false,
                                closeOnClickModal: false,
                                closeOnPressEscape: false
                                }).then(() => {
                                    window.location.reload()
                                }).catch(() => {});
                            return         
                    }


                    let {errIds, mulErr, mulexc} = get_err_info(resultData.data)
                    // 处理单个错误结果
                    let flag_single_err_html = get_flag_single_err_html(err['info'], resultData['msg'], mulErr, mulexc , old_current_name)

                    let current_tip = this.$notify({
                        showClose: false,
                        duration: 0,
                        dangerouslyUseHTMLString: true,
                        message: flag_single_err_html
                    })
                    this.$store.commit('apple/ADD_NOTIFY',{
                        id: `${old_current_name}_close`,
                        value: current_tip,
                    });

                    // 还原表格状态
                    let select_id = fetchparams['keyword_id']
                    let selectIndex = this.tableData.findIndex((element) => element['keyword_id'] == select_id)
                    if(selectIndex != -1) {
                        this.tableData[selectIndex]['keyword_status'] = this.tableData[selectIndex]['cache_keyword_status']
                        this.tableData[selectIndex]['keyword_display_status'] = this.tableData[selectIndex]['cache_keyword_display_status']
                        this.tableData[selectIndex]['keyword_display_status_name'] = this.tableData[selectIndex]['cache_keyword_display_status_name']
                        this.tableData[selectIndex]['keyword_status_disabled'] = false
                    }
                })
            },
            // 开关  多个
            handleSwithMul(select_name , prop_id, status, diatitle) {
                // 多个请求中
                this.dialogVisible = true
                this.dialogTypeTitle= diatitle
                
                let currency_time = new Date().valueOf()
                let current_name = `${select_name}_${currency_time}`
                let fetchparams = {keyword_id: prop_id, status: status, current_name: current_name,is_all:false}

                API.edittargeting(fetchparams,{
                    timeout: 120 * 1000,
                }).then(res=>{
                    let resultData = res.data

                    // 处理多个个请求中 关闭
                    this.dialogVisible = false
                    this.dialogTypeTitle= ''
                    // 单个请求成功
                    let flag_single_post_html = get_flag_suc_html(res['info'], resultData['msg'])
                    this.$notify({
                        showClose: false,
                        duration: 5000,
                        dangerouslyUseHTMLString: true,
                        message: flag_single_post_html
                    });

                    // 成功赋予表格状态
                    this.getListBody(this.props_params)
                    
                },err => {
                    let resultData = err.data
                    // 处理多个个请求中 关闭
                    this.dialogVisible = false
                    this.dialogTypeTitle= ''

                    if(err.code =='403'){
                        this.$confirm(err.info, '提示', {
                                confirmButtonText: '刷新',
                                type: 'warning',
                                showClose: false,
                                closeOnClickModal: false,
                                closeOnPressEscape: false
                                }).then(() => {
                                    window.location.reload()
                                }).catch(() => {});
                            return          
                    }

                    let {errIds, mulErr, mulexc} = get_err_info(resultData.data)
                    // 处理多个错误结果
                    let flag_mul_err_html = get_flag_mul_err_html(err['info'], resultData['msg'], mulErr, mulexc , current_name, errIds, 'keyword')

                    let current_tip = this.$notify({
                        showClose: false,
                        duration: 0,
                        dangerouslyUseHTMLString: true,
                        message: flag_mul_err_html
                    })
                    this.$store.commit('apple/ADD_NOTIFY',{
                        id: `${current_name}_close`,
                        value: current_tip,
                    });
                    // 多个失败表格状态不动
                    this.getListBody(this.props_params)
                })
            },

            // 开关  多个 全部
            handleSwithAllMul(select_name , prop_id, status, diatitle) {
                // 多个请求中
                this.dialogVisible = true
                this.dialogTypeTitle= diatitle
                
                let currency_time = new Date().valueOf()
                let current_name = `${select_name}_${currency_time}`
                let fetchparams = {query:prop_id, status: status, current_name: current_name,is_all:true}

                API.edittargeting(fetchparams,{
                    timeout: 120 * 1000,
                }).then(res=>{
                    let resultData = res.data

                    // 处理多个个请求中 关闭
                    this.dialogVisible = false
                    this.dialogTypeTitle= ''
                    // 单个请求成功
                    let flag_single_post_html = get_flag_suc_html(res['info'], resultData['msg'])
                    this.$notify({
                        showClose: false,
                        duration: 5000,
                        dangerouslyUseHTMLString: true,
                        message: flag_single_post_html
                    });

                    // 成功赋予表格状态
                    this.getListBody(this.props_params)
                    
                },err => {
                    let resultData = err.data
                    // 处理多个个请求中 关闭
                    this.dialogVisible = false
                    this.dialogTypeTitle= ''

                    if(err.code =='403'){
                        this.$confirm(err.info, '提示', {
                                confirmButtonText: '刷新',
                                type: 'warning',
                                showClose: false,
                                closeOnClickModal: false,
                                closeOnPressEscape: false
                                }).then(() => {
                                    window.location.reload()
                                }).catch(() => {});
                            return           
                    }

                    let {errIds, mulErr, mulexc} = get_err_info(resultData.data)
                    // 处理多个错误结果
                    let flag_mul_err_html = get_flag_mul_err_html(err['info'], resultData['msg'], mulErr, mulexc , current_name, errIds)

                    let current_tip = this.$notify({
                        showClose: false,
                        duration: 0,
                        dangerouslyUseHTMLString: true,
                        message: flag_mul_err_html
                    })
                    this.$store.commit('apple/ADD_NOTIFY',{
                        id: `${current_name}_close`,
                        value: current_tip,
                    });
                    // 多个失败表格状态不动
                    this.getListBody(this.props_params)
                })
            },
            
            // 处理表格内部blur事件
            handleDocumentKeywordClick(event) {
                if(this.active == -1) {
                    return
                }
                const targetAreas = this.$refs.myParagraphkey
                let isareas = targetAreas.some(item=> item.contains(event.target))
                const isOutsideClick = targetAreas && !isareas
                if (isOutsideClick) {
                    // 如果点击事件发生在指定区域外，隐藏指定区域
                    this.tableData[this.active]['bid_amount'] = this.tableData[this.active]['cache_bid_amount']
                    this.active = -1

                    const targetInput = this.$refs.myParagraphread 
                    if(Array.isArray(targetInput) && targetInput.length != 0) {
                        targetInput.forEach(item=>{
                            item.blur()
                        })
                    }else{
                        targetInput.blur()
                    }
                }
            },
            // 每日预算 focus
            handleFocus(val, index, type) {
                if(this.isHasAuth('edit_bid_amount')) return
                console.log(this.active, val, index, type)
                if(this.active != -1){
                    this.tableData[this.active]['bid_amount'] = this.tableData[this.active]['cache_bid_amount']
                }
                this.active = index
                // if(type == 'list') {
                //     this.active = index
                // }else{
                //     this.infoysactive = true
                // }
                
                // this.$refs.myParagraph[index].focus()
            },
            // 每日预算 blur
            handleBlur(index) {
                // this.active = -1
            },
            // 修改每日预算
            handleOK(values, select_name, type) {
                console.log(values, select_name)
                
                // 单个请求中
                let flag_single_post_html = get_flag_single_post_html(values['keyword_id'])

                let currency_time = new Date().valueOf()
                let current_name = `${select_name}_${currency_time}`
                let current_tip = this.$notify({
                    showClose: false,
                    duration: 0,
                    dangerouslyUseHTMLString: true,
                    message: flag_single_post_html
                });
                // this.notifyarr.push(notifyTip)

                this.$store.commit('apple/ADD_NOTIFY',{
                    id: current_name,
                    value: current_tip,
                });

                values['edit_bid_amount_disabled'] = true

                let fetchparams = {
                    keyword_id:[values['keyword_id']],
                    new_bid_amount: Number(values['bid_amount']),
                    action_type: 'new',
                    value_type: 'number',
                    current_name: current_name
                }
                this.checkSignKeywordBidAmount(fetchparams, current_name, select_name)
            },
            checkSignKeywordBidAmount(fetchparams, old_current_name, select_name) {
                API.editKeywordBidAmount(fetchparams).then(res=>{
                    let resultData = res.data

                    // 处理单个请求中 关闭
                    let current_closed = this.$store.getters.apple_notify[old_current_name]
                    if(current_closed) {
                        current_closed.close()
                    }
                    // 单个请求成功
                    let flag_single_post_html = get_flag_suc_html(res['info'], resultData['msg'])
                     this.$notify({
                        showClose: false,
                        duration: 5000,
                        dangerouslyUseHTMLString: true,
                        message: flag_single_post_html
                    });

                    // 赋予表格状态
                    let select_id = fetchparams['keyword_id'][0]
                    let selectIndex = this.tableData.findIndex((element) => element['keyword_id'] == select_id)
                    if(selectIndex != -1) {
                        this.tableData[selectIndex]['bid_amount'] = Number(resultData['bid_amount'])
                        this.tableData[selectIndex]['cache_bid_amount'] = Number(resultData['bid_amount'])
                        this.tableData[selectIndex]['edit_bid_amount_disabled'] = false
                        if(this.active == selectIndex){
                            this.active = -1
                        }
                    }

                },err => {
                    // 处理单个请求中 关闭
                    let resultData = err.data
                    let current_closed = this.$store.getters.apple_notify[old_current_name]
                    if(current_closed) {
                        current_closed.close()
                    }
                    if(err.code =='403'){
                        this.$confirm(err.info, '提示', {
                                confirmButtonText: '刷新',
                                type: 'warning',
                                showClose: false,
                                closeOnClickModal: false,
                                closeOnPressEscape: false
                                }).then(() => {
                                    window.location.reload()
                                }).catch(() => {});
                            return          
                    }
                    let {errIds, mulErr, mulexc} = get_err_info(resultData.data)
                    // 处理单个错误结果
                    let flag_single_err_html = get_flag_single_err_html(err['info'], resultData['msg'], mulErr, mulexc , old_current_name)

                    let current_tip = this.$notify({
                        showClose: false,
                        duration: 0,
                        dangerouslyUseHTMLString: true,
                        message: flag_single_err_html
                    })
                    this.$store.commit('apple/ADD_NOTIFY',{
                        id: `${old_current_name}_close`,
                        value: current_tip,
                    });

                    // 赋予表格状态
                    let select_id = fetchparams['keyword_id'][0]
                    let selectIndex = this.tableData.findIndex((element) => element['keyword_id'] == select_id)
                    if(selectIndex != -1) {
                        this.tableData[selectIndex]['bid_amount'] = this.tableData[selectIndex]['cache_bid_amount']
                        this.tableData[selectIndex]['edit_bid_amount_disabled'] = false
                        if(this.active == selectIndex){
                            this.active = -1
                        }
                    }
                })
            },
            handleClose(values, index, type) {
                if(type == 'list') {
                    this.active = -1;
                }else{
                    this.infoysactive = false
                }
                values['bid_amount'] = this.tableData[index]['cache_bid_amount']
            },
            // 只可以输入数字
            handleInput(val, rows, limit = 2) {

                if(rows.bid_amount_currency=='美元'){
                    let USDConfig = this.decimalConfig.find(item=>item.type=='keyword'&&item.field=='bid_amount'&&item.currency=='USD')||{};
                    limit = USDConfig.decimal_places||2;
                }

                let rval = val.replace(/[^0-9\d.]/g, ''); //保留数字

                // rval = rval.replace(/^00/, "0."); //开头不能有两个0
                rval = rval.replace(/^\./g, "0."); //开头为小数点转换为0.
                rval = rval.replace(/\.{2,}/g, "."); //两个以上的小数点转换成一个
                rval = rval.replace(".", "$#$").replace(/\./g, "").replace("$#$", "."); //只保留一个小数点
                /^0\d+/.test(rval) ? rval = rval.slice(1) : ''; //两位以上数字开头不能为0
                // rval = rval.replace(/[^0-9\d.]/g, '').replace(/^(-)?0(?!\.)/g, '')
                const str = '^(\\d+)\\.(\\d{' + limit + '}).*$'
                const reg = new RegExp(str)
                if (limit === 0) {
                    // 不需要小数点
                    rval = rval.replace(reg, '$1')
                } else {
                    // 通过正则保留小数点后指定的位数
                    rval = rval.replace(reg, '$1.$2')
                }
                rows.bid_amount = rval
            },
            // 导出
            handleExport() {
                this.exportLoading = true;
                API.exportKeywordList(this.props_params,{
                    timeout: 120 * 1000,
                }).then(res => {
                    this.exportLoading = false;
                    console.log('res', res)
                    this.$message({
                        message: res.info,
                        type: 'success'
                    });
                }, (err) => {
                    this.exportLoading = false;
                    if(err.code =='403'){
                        this.$confirm(err.info, '提示', {
                                confirmButtonText: '刷新',
                                type: 'warning',
                                showClose: false,
                                closeOnClickModal: false,
                                closeOnPressEscape: false
                                }).then(() => {
                                    window.location.reload()
                                }).catch(() => {});
                            return          
                    }
                    this.$message.error(err.info||'请求异常');
                })
            },
            handleDragEnd(newWidth, oldWidth, column) {
                console.log('handleDragEnd',newWidth,oldWidth,column)
                let getCurrentNameWidth = this.getLocalStorageWidth[this.pageName] || {}
                //存储示例格式 {address: 707, date: 184, name: 246}
                let result = Object.assign(getCurrentNameWidth, {
                    [column.property]: parseInt(newWidth),
                });
                setStorage('localStorage', 'tableWidthMap', Object.assign({},this.getLocalStorageWidth,{
                    [this.pageName]: result
                }) );
            },
            // 排序
            handlesortchange({column, prop, order}) {
                //ascending 升   descending 降
                console.log(column, prop, order)
                let order_type = order == 'ascending' ? 'asc' : (order=='descending'?'desc':'');
                this.props_params['order_by'] = order_type?prop:'';
                this.props_params['order_type'] = order_type
                this.getListBody(this.props_params)
            },
            // 排序显示
            getsortable(values, show) {
                if(values && values == 1 && other_Table_columns_no_sort.includes(show)) {
                    return 'custom'
                }
                return (values && values == 2) ? 'custom' : false
            },
            renderHeader(h, values, column) {
                let colName = column.name;
                let actionCol = this._findFieldByName(this.pageFields,colName)||{};
                let content_text = column['config'] && JSON.parse(column['config'])['title']
                let content_text1 = actionCol['config'] && JSON.parse(actionCol['config'])['title']
                // let content_width = '100px'
                // if(column['field_type'] == 2) {
                //     if(column['display_name'].length >= 8) {
                //         content_width = ((6 * 18)).toString()
                //     }
                // }
                let content_html = null
                if(column['field_type'] == 2) {
                    content_html = h(
                                    'el-tooltip',
                                        {
                                            props: {
                                            effect: 'dark',
                                            content: content_text1||content_text,
                                            placement: 'top',
                                            },
                                        },
                                        [
                                            h('i', {
                                            class: 'el-icon-question',
                                            style: 'margin-left:2px;'
                                            }),
                                        ]
                                    )
                }
                return h('div', {
                            style: 'display: inline-block;'
                        }, 
                [
                    h('div', {class: 'render-header-div'}, [
                        h('span', {
                                class: 'render-header-span'
                            }, values.column.label),
                        content_html
                    ])
                    
                ])
            },
            // 分页 切换条数
            handleSizeChange(val) {
                this.props_params.rn = val
                this.props_params.pn = 1
                this.rn = val
                this.pn = 1
                this.getListBody(this.props_params)
            },
            // 分页 选择页数
            handleCurrentChange(val) {
                this.props_params.pn = val
                this.pn = val
                this.getListBody(this.props_params)
            },
            searchList(){
                let routeParams = this.$route.params||{};
                let $query = this.$refs.query;
                console.log('searchList',routeParams,this.zone,this.rangeTime,$query.getQueryData());
            },
            getSearchList(isClear){
                if(!isClear){
                    this.props_params.range_time = this.rangeTime.join('/');
                    this.props_params.time_zone = this.zone;
                    this.getListBody(this.props_params);
                }else{
                    this.$refs.query.resetForm();
                }
            },
            handleClickCampaignName(row){
                console.log('handleClickCampaignName',row);
                if(this.isHasAdGroupAction){
                    this.$router.push({
                        name:'apple_adgroup',
                        query:{
                            campaign_id:[row.campaign_id],
                            campaign_name:[row.campaign_name],
                        },
                        params:{
                            range:this.rangeTime,
                            zone:this.zone,
                        },
                    });
                }else{
                    this.$message.error('暂时无法跳转该页面');
                }
            },
            async getRelatesInfo(data){
                let keyArr = Object.keys(data||{});
                if(keyArr.length<=0) return;
                // let isMultiData = keyArr.some(item=>Array.isArray(data[item])&&data[item].length>1);
                // if(isMultiData) return console.log('筛选项有多个，无法带入相关信息哦');
                //
                // let reqData = {};
                // keyArr.forEach(item=>{
                //     let dataItem = data[item];
                //     if(Array.isArray(dataItem)){
                //         reqData[item] = dataItem[0];
                //     }else{
                //         reqData[item] = dataItem;
                //     }
                // });

                let res = await API.getRelatesInfo({...data});
                let resData = res.data||{};
                this.preData = {...resData};
                console.log('getRelatesInfo',resData);
            },
            handleClickAdd(){
                console.log('handleClickAdd');
                this.addLoading = true;
                let storeQueryData = this.apple_list_page_query;
                API.checkKeywordAddKeyword().then(async ()=>{
                    this.addLoading = false;
                    this.actionType = 'keywordAddKeyword';
                    await this.getRelatesInfo({
                        org_id:storeQueryData.org_id,
                        org_name:storeQueryData.org_name,
                        campaign_id:storeQueryData.campaign_id,
                        campaign_name:storeQueryData.campaign_name,
                        adgroup_id:storeQueryData.adgroup_id,
                        adgroup_name:storeQueryData.adgroup_name,
                    });
                    this.$refs.keywordModal.showModal({...this.preData});
                },err=>{
                    this.addLoading = false;
                    this.$message.error(err.info||'请求异常');
                })
            },
            clearMultipleSelection(){
                this.multipleSelection = [];
                this.$refs.multipleTable.clearSelection();
            },
            showDataModal(row){
                let bidAmount = this._findFieldByName(this.pageDimension,'bid_amount');
                dataDetailModal({
                    props:{
                        customClass:'modal-body-padding-top-10 modal-body-padding-bottom-10 modal-body-min-height-500',
                        data:{...row},
                        title:'关键词：'+row.key_word_text,
                        type:'keyword',   // org,campaign,adgroup,keyword,search_term
                        selectList:this.selectList,
                        pageFields:this.pageFields,
                        bidAmount:bidAmount,
                        query:{
                            time_zone:this.zone,
                            range_time:this.rangeTime,
                        },
                    },
                    cbs:{
                    },
                })
            },
            _findFieldByName(data, name) {
                for (let item in data) {
                    if (data[item].name == name) {
                        return data[item];
                    } else {
                        let child = data[item].children;
                        if (child && child.length > 0) {
                            let result = this._findFieldByName(child, name);
                            if (result) {
                                return result;
                            }
                        }
                    }
                }
            },
        }
    }
</script>

<style lang="scss" scoped>
    @import "~@/styles/apple_sd.scss";
    #operation-box ::v-deep{
        .sub-menu-item-all{
            color: #333;
        }
        .apple-cascader.el-menu--horizontal{
            border-bottom: none;
            .el-submenu__title,.el-menu-item{
                font-size: 12px;
                border-bottom: none;
                padding: 0 15px!important;
            }
            .el-menu-item:hover{
                background-color:#ecf5ff;
            }
            .err-menu-item:hover{
                background-color:#fef0f0!important;
            }
            .err-menu-item.el-submenu:hover,.err-menu-item.is-opened{
                .el-submenu__title{
                    background-color:#fef0f0!important;
                }
            }
            &>.err-menu-item .el-submenu__title:hover{
                background-color: #fef0f0!important;
            }
            &>.el-submenu .el-submenu__title:hover{
                background-color: #ecf5ff;
            }
            &>.el-submenu>.el-submenu__title{
                font-size: 12px;
                padding: 0 15px!important;
                color: #409eff;
                background: #ecf5ff;
                border: solid 1px #b3d8ff;
                height: 28px;
                line-height: 26px;
                border-radius: 3px;
                border-bottom-color: #b3d8ff!important;
                .el-submenu__icon-arrow{
                    color: #409eff;
                    display: inline-block!important;
                }
                &:hover{
                    background: #409eff;
                    border-color: #409eff;
                    color: #fff;
                    .el-submenu__icon-arrow{
                        color: #fff;
                    }
                }
            }
        }
    }



.custom_input{
    .el-input__inner{
        padding: 0 8px;
    }
    .el-input-group__append{
        padding: 0 8px;
    }
}

</style>
<style lang="scss" scoped>
    .com-table-view-apple{
        background: #fff;
        /*padding: 10px 10px 10px;*/
        padding: 10px 0 10px;
        border-radius: 3px;
        border: 1px solid #e8eaec;
        margin-top: 10px;
        /*box-shadow: 0 1px 2px 0 rgba(0,0,0,.2);*/
        .operation-box{
            display: flex;
            justify-content:space-between;
            align-items: center;
            margin-bottom: 10px;
            padding: 0 15px;
            .operation-left{
                display: flex;
                justify-content:flex-start;
                align-items: center;
            }
        }
        .component_pagination{
            padding-top: 20px;
            padding-right: 20px;
            text-align: right;
        }
    }
    .custom_input{
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 3px;
        padding: 3px;
        .el-input-group__append{
            padding: 0 8px;
        }
        &.active{
            box-shadow: 0 1px 8px #bbb6b6;
        }
        .custom_input_el{
            margin-right: 4px;
            flex: auto;
        }
        .custom_input_btn{
            width: 48px;
            flex: 0 0 48px;
            display: flex;
            justify-content: space-evenly;
            align-items: center;
        }
        .custom_input_success{
            width: 20px;
            height: 20px;
            line-height: 20px;
            border: 2px solid #67C23A;
            border-radius: 10px;
            background-color: #67C23A;
            text-align: center;
            cursor: pointer;
            &.btn-disabled{
                border: 2px solid #9ed881;
                background-color: #9ed881;
                cursor: no-drop;
            }
            i{
                color: #fff;
                font-weight: bold;
            }
        }
        .custom_input_close{
            width: 20px;
            height: 20px;
            line-height: 20px;
            border-radius: 10px;
            border: 2px solid #F56C6C;
            background-color: #F56C6C;
            text-align: center;
            cursor: pointer;
            &.btn-disabled{
                border: 2px solid #fe9999;
                background-color: #fe9999;
                cursor: no-drop;
            }
            i{
                color: #fff;
                font-weight: bold;
            }
        }
    }
    .table_operate{
        display: flex;
        justify-content: flex-start;
        align-items: center;
        span{
            cursor: pointer;
        }
    }
    .custom_drawer{
        padding: 0 8px;
        .title{
            display: flex;
            justify-content: space-between;
            align-items: center;
            border-bottom: 1px solid #e8eaec;
            padding: 8px 4px;
        }
        .drawer_list{
            padding: 8px 0;
            h4{
                font-size: 14px;
                margin-bottom: 8px;
            }
            .drawer_item{
                display:flex;
                align-items: center;
                padding: 4px 0;
                &>div{
                    &:first-child {
                        width: 100px;
                        flex: 0 0 100px;
                        padding-left: 16px;
                        color: #272727;
                    }
                    &:last-child {
                        flex: auto
                    }
                }
            }
        }
        .custom_input{
            align-items: flex-end;
            &.center{
                align-items: center;
            }
        }
    }
    .nodata{
        min-height: 300px;
    }
</style>


